module.exports = __webpack_public_path__ + "img/preview-8.3e426cf2.png";